import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
  curriculumGridContainer: {
    padding: theme.spacing(0, 2),
  },
  detailOfferTabsContainer: {
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.down(1200)]: {
      marginTop: theme.spacing(4.25),
    },
    [theme.breakpoints.down(1070)]: {
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.down(900)]: {
      marginTop: theme.spacing(1.25),
    },
    [theme.breakpoints.down(700)]: {
      marginTop: theme.spacing(1.5),
    },
    [theme.breakpoints.down(600)]: {
      marginTop: theme.spacing(3),
    },
    [theme.breakpoints.down(500)]: {
      marginTop: 0,
    },
  },
  dateBox: {
    "& .day-month": {
      fontSize: 30,
      fontWeight: 900,
      width: 56,
      height: 56,
      color: "#fff",
      borderRadius: "50%",
      textAlign: "center",
      padding: 5,
      margin: "18px auto",
      "&:nth-child(even)": {
        color: "#f0f0f0",
      },
    },
    "& .day": {
      marginTop: 4,
    },
    "& .month": {
      marginTop: -5,
    },
    "& .even-color": {
      backgroundColor: "#1c608a",
      color: "white",
    },
    "& .odd-color": {
      backgroundColor: "#f28704",
      color: "white",
    },
    "& .hour": {
      fontSize: 10,
      color: "rgba(0, 0, 0, 0.6666666667)",
      marginBottom: 5,
      paddingLeft: 35,
      textAlign: "left",
      float: "left",
      position: "relative",
      top: -7,
    },
  },
  gridBox: {
    paddingBottom: theme.spacing(1.25),
    "&:nth-child(even)": {
      background: "#f0f0f0",
      marginBottom: theme.spacing(1.25),
      paddingBottom: 0,
      borderRadius: 10,
    },
    "&.dark:nth-child(even)": {
      background: "#242424",
    },
    "& .no-schedule": {
      fontSize: 16,
      fontWeight: 600,
    },
  },
  detailOfferContainer: {
    "& .tab-label": {
      display: "flex",
      alignItems: "center",
      "& .tab-icon": {
        marginRight: 5,
        fontSize: 18,
      },
    },
  },
  detailingDescription: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    wordWrap: "break-word",
    "& > div": {
      maxWidth: "100%",
      overflow: "hidden",
      "& *": {
        maxWidth: "100%",
        boxSizing: "border-box",
      },
      "& img": {
        maxWidth: "100%",
        height: "auto",
      },
      "& table": {
        maxWidth: "100%",
        tableLayout: "auto",
        wordBreak: "break-word",
      },
      "& pre": {
        maxWidth: "100%",
        overflow: "auto",
        wordBreak: "break-word",
        whiteSpace: "pre-wrap",
      },
    },
  },
})); 